import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";
import { useRetailerStore } from "../RetailerStore";
export var useIsValidRetailer = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailerToken = useRetailer().retailerToken;
    var _useRetailerStore = useRetailerStore([
        "isValidRetailer"
    ]), isValidRetailerConteol = _useRetailerStore.isValidRetailer;
    var user = useUserStore([
        "user"
    ]).user;
    // Only check for the existence of retailer token is not sufficient because
    // a brand user can also have a retailer token that looks like r_{brandToken}
    var isValidRetailer = !!retailerToken && !!user && !!user.roles && user.roles.indexOf(UserRole.RETAILER) !== -1;
    if (shouldUseHooksMigration) {
        return {
            isValidRetailer: isValidRetailer
        };
    }
    return {
        isValidRetailer: isValidRetailerConteol
    };
};
